export function firstUpperCase(string) {
  if (!string.length) {
    return '';
  }
  return string[0].toUpperCase() + string.slice(1);
}

export function toDate(string, mask) {
  function getNum(v, m, t) {
    const a = m.indexOf(t);
    let b = '';
    for (let i = 0; i < t.length; i += 1) {
      b += v[a + i];
    }
    const c = parseInt(b, 10);
    return c || 0;
  }

  if (!string || string === '-') {
    return null;
  }
  const m = mask || 'dd.MM.yyyy';
  return new Date(
    getNum(string, m, 'yyyy'),
    getNum(string, m, 'MM') - 1,
    getNum(string, m, 'dd'),
  );
}

export function toLatin(string) {
  if (!string) {
    return '';
  }
  return string
    .replace(/а/g, 'a')
    .replace(/А/g, 'A')
    .replace(/б/g, 'b')
    .replace(/Б/g, 'B')
    .replace(/в/g, 'v')
    .replace(/В/g, 'V')
    .replace(/г/g, 'g')
    .replace(/Г/g, 'G')
    .replace(/д/g, 'd')
    .replace(/Д/g, 'D')
    .replace(/е/g, 'e')
    .replace(/Е/g, 'E')
    .replace(/ё/g, 'e')
    .replace(/Ё/g, 'E')
    .replace(/ж/g, 'zh')
    .replace(/([A-ZА-Я])Ж/g, 'ZH$1')
    .replace(/Ж([A-ZА-Я])/g, 'ZH$1')
    .replace(/Ж/g, 'Zh')
    .replace(/з/g, 'z')
    .replace(/З/g, 'Z')
    .replace(/и/g, 'i')
    .replace(/И/g, 'I')
    .replace(/й/g, 'i')
    .replace(/Й/g, 'I')
    .replace(/к/g, 'k')
    .replace(/К/g, 'K')
    .replace(/л/g, 'l')
    .replace(/Л/g, 'L')
    .replace(/м/g, 'm')
    .replace(/М/g, 'M')
    .replace(/н/g, 'n')
    .replace(/Н/g, 'N')
    .replace(/о/g, 'o')
    .replace(/О/g, 'O')
    .replace(/п/g, 'p')
    .replace(/П/g, 'P')
    .replace(/р/g, 'r')
    .replace(/Р/g, 'R')
    .replace(/с/g, 's')
    .replace(/С/g, 'S')
    .replace(/т/g, 't')
    .replace(/Т/g, 'T')
    .replace(/у/g, 'u')
    .replace(/У/g, 'U')
    .replace(/ф/g, 'f')
    .replace(/Ф/g, 'F')
    .replace(/х/g, 'kh')
    .replace(/([A-ZА-Я])Х/g, 'KH$1')
    .replace(/Х([A-ZА-Я])/g, 'KH$1')
    .replace(/Х/g, 'Kh')
    .replace(/ц/g, 'tc')
    .replace(/([A-ZА-Я])Ц/g, 'TC$1')
    .replace(/Ц([A-ZА-Я])/g, 'TC$1')
    .replace(/Ц/g, 'Tc')
    .replace(/ч/g, 'ch')
    .replace(/([A-ZА-Я])Ч/g, 'CH$1')
    .replace(/Ч([A-ZА-Я])/g, 'CH$1')
    .replace(/Ч/g, 'Ch')
    .replace(/ш/g, 'sh')
    .replace(/([A-ZА-Я])Ш/g, 'SH$1')
    .replace(/Ш([A-ZА-Я])/g, 'SH$1')
    .replace(/Ш/g, 'Sh')
    .replace(/щ/g, 'shch')
    .replace(/([A-ZА-Я])Щ/g, 'SHCH$1')
    .replace(/Щ([A-ZА-Я])/g, 'SHCH$1')
    .replace(/Щ/g, 'Shch')
    .replace(/ь/gi, '')
    .replace(/ы/g, 'y')
    .replace(/Ы/g, 'Y')
    .replace(/ъ/gi, '')
    .replace(/э/g, 'e')
    .replace(/Э/g, 'E')
    .replace(/ю/g, 'iu')
    .replace(/([A-ZА-Я])Ю/g, 'IU$1')
    .replace(/Ю([A-ZА-Я])/g, 'IU$1')
    .replace(/Ю/g, 'Iu')
    .replace(/я/g, 'ia')
    .replace(/([A-ZА-Я])Я/g, 'IA$1')
    .replace(/Я([A-ZА-Я])/g, 'IA$1')
    .replace(/Я/g, 'Ia');
}

export function toCyrillic(string) {
  if (!string) {
    return '';
  }
  const firstCapital = !!string.match(/^[A-Z]{1}/g);
  const result = this
    .replace(/all/gi, 'ол')
    .replace(/get/gi, 'гет')
    .replace(/lux/gi, 'люкс')
    .replace(/shch/gi, 'щ')
    .replace(/sch/gi, 'щ')
    .replace(/sch/gi, 'щ')
    .replace(/shh/gi, 'щ')
    .replace(/fuck/gi, 'фак')
    .replace(/ower/gi, 'ауэ')
    .replace(/air/gi, 'эа')
    .replace(/eir/gi, 'эа')
    .replace(/ite/gi, 'айт')
    .replace(/ear/gi, 'эа')
    .replace(/are/gi, 'эа')
    .replace(/our/gi, 'ауэ')
    .replace(/tch/gi, 'ч')
    .replace(/tc/gi, 'ц')
    .replace(/wr/gi, 'р')
    .replace(/who /gi, 'ху ')
    .replace(/who/gi, 'хo')
    .replace(/ou/gi, 'а')
    .replace(/oo/gi, 'у')
    .replace(/wh/gi, 'в')
    .replace(/qu/gi, 'кв')
    .replace(/th/gi, 'з')
    .replace(/cz/gi, 'ц')
    .replace(/cy/gi, 'сy')
    .replace(/ci/gi, 'сi')
    .replace(/ce/gi, 'сe')
    .replace(/gy/gi, 'джy')
    .replace(/gi/gi, 'джi')
    .replace(/ge/gi, 'джe')
    .replace(/zh/gi, 'ж')
    .replace(/iew/gi, 'ью')
    .replace(/yu/gi, 'ю')
    .replace(/yu/gi, 'ю')
    .replace(/ya/gi, 'я')
    .replace(/yo/gi, 'ё')
    .replace(/kh/gi, 'х')
    .replace(/ch/gi, 'ч')
    .replace(/sh/gi, 'ш')
    .replace(/iu/gi, 'ю')
    .replace(/ia/gi, 'я')
    .replace(/io /gi, 'ио ')
    .replace(/io/gi, 'ё')
    .replace(/aw /gi, 'о ')
    .replace(/aw/gi, 'ау')
    .replace(/ea/gi, 'и')
    .replace(/ay/gi, 'эй')
    .replace(/uy/gi, 'ай')
    .replace(/ph/gi, 'ф')
    .replace(/ck/gi, 'к')
    .replace(/ts/gi, 'ц')
    .replace(/ee/gi, 'и')
    .replace(/ue/gi, 'ью')
    .replace(/ye/gi, 'ай')
    .replace(/a/gi, 'а')
    .replace(/b/gi, 'б')
    .replace(/v/gi, 'в')
    .replace(/g/gi, 'г')
    .replace(/d/gi, 'д')
    .replace(/z/gi, 'з')
    .replace(/i/gi, 'и')
    .replace(/k/gi, 'к')
    .replace(/l/gi, 'л')
    .replace(/m/gi, 'м')
    .replace(/n/gi, 'н')
    .replace(/o/gi, 'о')
    .replace(/p/gi, 'п')
    .replace(/r/gi, 'р')
    .replace(/e /gi, ' ')
    .replace(/e/gi, 'е')
    .replace(/s/gi, 'с')
    .replace(/c/gi, 'к')
    .replace(/t/gi, 'т')
    .replace(/u/gi, 'у')
    .replace(/f/gi, 'ф')
    .replace(/h/gi, 'х')
    .replace(/j/gi, 'ж')
    .replace(/q/gi, 'к')
    .replace(/w/gi, 'в')
    .replace(/x/gi, 'кс')
    .replace(/аy/gi, 'ай')
    .replace(/еy/gi, 'ей')
    .replace(/иy/gi, 'ий')
    .replace(/оy/gi, 'ой')
    .replace(/уy/gi, 'уй')
    .replace(/yy/gi, 'ый')
    .replace(/y /gi, 'и ')
    .replace(/y/gi, 'ы');

  return firstCapital ? firstUpperCase(result) : result;
}

export function toTranslit(string) {
  if (!string) {
    return '';
  }
  if (string.replace(/[^a-zа-я]/gi, '')
    .match(/^[a-z]{1}/gi)) {
    return toCyrillic(string);
  }
  return toLatin(string);
}

export default {
  firstUpperCase,
  toDate,
  toLatin,
  toCyrillic,
  toTranslit,
};
